var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[_c('a-modal',{staticStyle:{"height":"900px"},attrs:{"title":_vm.getTitle,"width":1300,"centered":"","mask-closable":false,"footer":false},on:{"cancel":_vm.closed},model:{value:(_vm.visible),callback:function ($$v) {_vm.visible=$$v},expression:"visible"}},[_c('plan-case-list',{attrs:{"plan-id":_vm.planId,"result-disabled":false}})],1)],1)
}
var staticRenderFns = []

export { render, staticRenderFns }